// テーマ全体に関わるJS処理を記述

// Scroll to Top
function backToTop() {
  const btnArray = document.querySelectorAll(".c-back-to-top");
  btnArray.forEach((btn) => {
    btn.addEventListener("click", function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  });
}

window.addEventListener('DOMContentLoaded',function(){
  backToTop();
});


/*
	-- カントリーブロック/Global-e課題であるPlaceholderが商品ブロックに表示されてしまう問題を一時的に制御 --
*/
(() => {
  // 衝突回避のための一意キー
  const KEY = '__uaFeaturedCleaner';
  if (window[KEY]) return;
  window[KEY] = true;

  // デフォルト商品かどうかの判定ロジック（安全側で複数条件をOR）
  const isDefaultProduct = (item) => {
    if (!item) return false;

    // 画像がプレースホルダー
    if (item.querySelector('.product-item__image-wrapper--placeholder')) return true;

    const vendorEl = item.querySelector('.product-item-meta__vendor');
    const titleEl  = item.querySelector('.product-item__title');
    const priceEl  = item.querySelector('.price');

    const vendor = vendorEl?.textContent.trim();
    const title  = titleEl?.textContent.trim();
    const href   = titleEl?.getAttribute('href');
    const priceDigits = (priceEl?.textContent || '').replace(/[^\d]/g, '');

    // a[href="#"] はダミー
    if (href === '#') return true;

    // 文言が明らかなデフォルト値
    if ((vendor === '販売者' || /vendor|販売者/i.test(vendor || '')) &&
        (title  === '製品'   || /product|製品/i.test(title  || ''))) return true;

    // デフォルト価格（¥50）に一致
    if (priceDigits === '50') return true;

    return false;
  };

  const cleanList = (listEl) => {
    if (!listEl || listEl.dataset.uaCleaned === '1') return;
    const inner = listEl.querySelector('.product-list__inner');

    // 「product」というテキストノード（テーマのデバッグ出力）を除去
    if (inner) {
      [...inner.childNodes].forEach((n) => {
        if (n.nodeType === 3 && n.textContent.trim() === 'product') n.remove();
      });
    }

    // デフォルト商品のみ削除
    const items = [...listEl.querySelectorAll('product-item.product-item')];
    let removed = 0;
    items.forEach((item) => {
      if (isDefaultProduct(item)) {
        item.remove();
        removed++;
      }
    });

    // 一つも残らなければセクションごと非表示
    const remains = listEl.querySelectorAll('product-item.product-item').length;
    if (remains === 0) {
      const section = listEl.closest('section.section');
      if (section) section.style.display = 'none';
    }

    // 再実行抑止
    listEl.dataset.uaCleaned = '1';
    return removed;
  };

  const run = () => {
    document
      .querySelectorAll('.featured-collections .product-list, .c-featured-collections .product-list')
      .forEach(cleanList);
  };

  // 初回実行（DOM Ready）
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Global-e 等が後からDOMを書き換える場合に備えて監視
  const root = document.querySelector('.featured-collections, .c-featured-collections') || document.body;
  const mo = new MutationObserver((mutations) => {
    let shouldRun = false;
    for (const m of mutations) {
      if (m.addedNodes && m.addedNodes.length) {
        for (const n of m.addedNodes) {
          if (n.nodeType === 1 && (
              n.matches?.('.product-list, product-list') ||
              n.querySelector?.('.product-list, product-list')
            )) {
            shouldRun = true;
            break;
          }
        }
      }
      if (shouldRun) break;
    }
    if (shouldRun) run();
  });
  mo.observe(root, { childList: true, subtree: true });
})();

